export default __webpack_public_path__ + "static/recognisable-dark-94bfe011f12208f81fcddb9919262571da737989a03b603f875d8a5daba47cb3.png";